export const INR = (n) => {
  if (n === null || n === undefined || isNaN(Number(n))) return "₹ 0.00";
  const num = Number(n);
  const sign = num < 0 ? "-" : "";
  const abs = Math.abs(num);
  return `${sign}₹ ${abs.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const num2 = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const today = () => new Date().toISOString().slice(0, 10);

export const prettyDate = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};
